import { detectPlatform, loadKeymap, matchKey, type KeyState } from "../input/keymap.ts";
import { focusOwnsKey } from "../input/typing.ts";
import { listStreetViewKeyboardTargets } from "./register.ts";

function keyState(e: KeyboardEvent): KeyState {
  return { code: e.code, alt: e.altKey, shift: e.shiftKey, ctrl: e.ctrlKey, meta: e.metaKey };
}

function isTyping(target: EventTarget | null, code: string): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const type = target instanceof HTMLInputElement ? target.type : undefined;
  return focusOwnsKey({ tagName: target.tagName, type, isContentEditable: target.isContentEditable }, code);
}

function prefStore(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

function pegmanVisible(button: HTMLButtonElement): boolean {
  if (button.hidden) return false;
  if (button.getClientRects().length === 0) return false;
  return true;
}

/**
 * Plain P (or a remapped toggleStreetView chord) opens Naver street view in a new tab
 * for every visible pegman control. Returns true when the key was handled.
 */
export function streetViewOpenFromKey(
  e: KeyboardEvent,
  opts: { settingsOpen?: boolean; keymapCapture?: boolean },
): boolean {
  if (opts.keymapCapture || opts.settingsOpen) return false;
  if (e.repeat) return false;
  const store = prefStore();
  if (!store) return false;
  const platform = detectPlatform();
  const { keymap } = loadKeymap(store);
  if (matchKey(keymap, keyState(e), platform) !== "toggleStreetView") return false;
  if (isTyping(e.target, e.code)) return false;
  let opened = false;
  for (const { button, open } of listStreetViewKeyboardTargets()) {
    if (!pegmanVisible(button)) continue;
    open();
    opened = true;
  }
  if (opened) {
    e.preventDefault();
    e.stopPropagation();
  }
  return opened;
}
